import React, { useEffect, useState } from "react";
import useMousePosition from "../hooks/useMousePosition";
import MainStore from "../stores/MainStore";
import useHandleBoxTypes from "../hooks/useHandleBoxTypes";

const DragCursor = () => {
  const { x, y } = useMousePosition();
  const { dragCursor, hideCursor } = MainStore();
  const { icon, setIcon } = useState("");
  const { getBoxType } = useHandleBoxTypes();

  useEffect(() => {
    if (dragCursor) {
      setIcon(getBoxType(dragCursor.type, true).icon);
    }
  }, [dragCursor]);

  return (
    <div
      style={{
        left: `${x}px`,
        top: `${y}px`,
        position: "absolute",
        transform: "translate(-50%, -50%)",
        zIndex: 999999,
        pointerEvents: "none",
      }}
    >
      {dragCursor && !hideCursor && <img className="icon40" src={icon} />}
    </div>
  );
};

export default DragCursor;
